import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const imageValidation = () => {
    return yup.object().shape({
        name: yup.string().required(ERRORS.required),
    });
};
